webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(45);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(41);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _axios = __webpack_require__(9);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _vueAxios = __webpack_require__(40);
	
	var _vueAxios2 = _interopRequireDefault(_vueAxios);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vueAxios2.default, _axios2.default);
	
	new _vue2.default({
	  el: '#app',
	  template: '<App/>',
	  components: { App: _App2.default }
	});

/***/ }),

/***/ 27:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Dictionary = __webpack_require__(42);
	
	var _Dictionary2 = _interopRequireDefault(_Dictionary);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    Dictionary: _Dictionary2.default
	  }
	};

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _clipboard = __webpack_require__(30);
	
	var _clipboard2 = _interopRequireDefault(_clipboard);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: 'Dictionary',
		data: function data() {
			return {
				tableSelectView: false,
				activeTabindex: 0,
				mysqldata: {},
				currentTableData: {},
				clickHistory: {},
				emptyHistory: true,
				tableListView: false,
				tableDescView: false,
				summary: ''
			};
		},
	
		methods: {
			selectNavTab: function selectNavTab(i, event) {
				this.activeTabindex = i;
			},
			initCopy: function initCopy(target, val) {
				var clipboard = new _clipboard2.default(target, {
					text: function text() {
						return val;
					}
				});
				clipboard.on('success', function (e) {
					console.log('success');
					clipboard.destroy();
				});
				clipboard.on('error', function (e) {
					console.log('error');
					clipboard.destroy();
				});
			},
			CopyThat: function CopyThat(val, event) {
				var app = this;
				app.initCopy(event.target, val);
			},
			viewTable: function viewTable(tablename, event) {
				var app = this;
				app.initCopy(event.target, tablename);
				if (app.currentTableData.tablename == tablename) {
					return false;
				}
				app.tableListView = false;
				app.tableDescView = false;
	
				if (app.emptyHistory) {
					app.emptyHistory = false;
				}
				if (app.clickHistory[tablename]) {
					app.clickHistory[tablename].pv += 1;
				} else {
					app.clickHistory[tablename] = app.mysqldata.tables[tablename];
					app.clickHistory[tablename].pv = 1;
				}
				app.viewTableFields(tablename);
			},
			viewTableFields: function viewTableFields(tablename) {
				var app = this;
	
				app.currentTableData.tablename = tablename;
				app.currentTableData.info = app.mysqldata.tables[tablename];
				app.currentTableData.fields = app.mysqldata.tableFields[tablename];
				setTimeout(function () {
					app.tableDescView = true;
				}, 20);
			},
			viewTableList: function viewTableList() {
				var app = this;
				if (app.tableListView) {
					alert('已经是首页了');
					return false;
				}
				app.tableListView = true;
				app.tableDescView = false;
				app.currentTableData = {};
			},
			makeData: function makeData() {
				var app = this;
				app.axios.get('data/initdata.php?t=' + new Date().valueOf()).then(function (response) {
					if (response.data instanceof Object == false) {
						alert('生成数据需要把项目部署到PHP环境中,用来读取数据库生成数据字典文件');
					} else {
						alert(response.data.message);
						window.location.reload();
					}
				}).catch(function (error) {
					console.log(error);
				});
			},
			getData: function getData() {}
		},
		filters: {
			defaultVal: function defaultVal(value, _defaultVal) {
				if (!value) return _defaultVal;
				return value;
			}
		},
		beforeCreate: function beforeCreate() {
			var app = this;
			app.axios.get('data/data.json?t=' + new Date().valueOf()).then(function (response) {
				app.mysqldata = response.data;
				console.log(app.mysqldata);
			}).catch(function (error) {
				console.log(error);
			});
		},
		computed: {
			getClickHistory: function getClickHistory() {
				return this.clickHistory;
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			setTimeout(function () {
				_this.tableSelectView = true;
				_this.tableListView = true;
			}, 20);
		}
	};

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(34)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(27),
	  /* template */
	  __webpack_require__(44),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(33)
	
	var Component = __webpack_require__(8)(
	  /* script */
	  __webpack_require__(28),
	  /* template */
	  __webpack_require__(43),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 43:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "container"
	  }, [_c('transition', {
	    attrs: {
	      "name": "custom-classes-transition",
	      "enter-active-class": "animated bounceInLeft"
	    }
	  }, [(_vm.tableSelectView) ? _c('div', {
	    staticClass: "table-select"
	  }, [_c('div', {
	    staticClass: "tab-nav"
	  }, [_c('div', {
	    class: [_vm.activeTabindex == 0 ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.selectNavTab(0, $event)
	      }
	    }
	  }, [_vm._v("表名\n\t\t\t\t")]), _vm._v(" "), _c('div', {
	    staticClass: "middle",
	    class: [_vm.activeTabindex == 1 ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.selectNavTab(1, $event)
	      }
	    }
	  }, [_vm._v("\n\t\t\t\t\t备注名\n\t\t\t\t")]), _vm._v(" "), _c('div', {
	    class: [_vm.activeTabindex == 2 ? 'active' : ''],
	    on: {
	      "click": function($event) {
	        _vm.selectNavTab(2, $event)
	      }
	    }
	  }, [_vm._v("点击记录")])]), _vm._v(" "), _c('div', {
	    staticClass: "tab-content"
	  }, [_c('ul', {
	    class: [_vm.activeTabindex == 0 ? 'show' : '']
	  }, _vm._l((_vm.mysqldata.tables), function(value, key, index) {
	    return _c('li', {
	      staticClass: "copy",
	      class: [key == _vm.currentTableData.tablename ? 'active' : ''],
	      on: {
	        "click": function($event) {
	          _vm.viewTable(key, $event)
	        }
	      }
	    }, [_c('p', [_c('i', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(key))])])
	  })), _vm._v(" "), _c('ul', {
	    class: [_vm.activeTabindex == 1 ? 'show' : '']
	  }, _vm._l((_vm.mysqldata.tables), function(value, key, index) {
	    return _c('li', {
	      class: [key == _vm.currentTableData.tablename ? 'active' : ''],
	      on: {
	        "click": function($event) {
	          _vm.viewTable(key, $event)
	        }
	      }
	    }, [_c('p', [_c('i', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(_vm._f("defaultVal")(value.comment, key)))])])
	  })), _vm._v(" "), _c('ul', {
	    class: [_vm.activeTabindex == 2 ? 'show' : '']
	  }, [_vm._l((_vm.clickHistory), function(value, key, index) {
	    return _c('li', {
	      class: [key == _vm.currentTableData.tablename ? 'active' : ''],
	      on: {
	        "click": function($event) {
	          _vm.viewTable(key, $event)
	        }
	      }
	    }, [_c('p', [_c('i', [_vm._v(_vm._s(index + 1))]), _vm._v(_vm._s(key) + " (" + _vm._s(value.pv) + ")次")])])
	  }), _vm._v(" "), _c('li', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.emptyHistory),
	      expression: "emptyHistory"
	    }]
	  }, [_c('p', [_c('i', [_vm._v("0")]), _vm._v("暂无记录")])])], 2)])]) : _vm._e()]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "custom-classes-transition",
	      "enter-active-class": "animated bounceInRight",
	      "leave-active-class": "animated bounceOutLeft"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.tableListView),
	      expression: "tableListView"
	    }],
	    staticClass: "table-list"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("项目数据库字典")])]), _vm._v(" "), _c('div', {
	    staticClass: "table-row"
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("编号")]), _vm._v(" "), _c('th', {
	    attrs: {
	      "width": "30%"
	    }
	  }, [_vm._v("表名")]), _vm._v(" "), _c('th', [_vm._v("表类型")]), _vm._v(" "), _c('th', [_vm._v("备注")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.mysqldata.tables), function(value, key, index) {
	    return _c('tr', [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_c('p', {
	      staticClass: "copy",
	      on: {
	        "click": function($event) {
	          _vm.viewTable(key, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(key))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(value.engine))]), _vm._v(" "), _c('td', {
	      staticClass: "copy",
	      on: {
	        "click": function($event) {
	          _vm.CopyThat(value.comment, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(value.comment))])])
	  }))])])])])]), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "custom-classes-transition",
	      "enter-active-class": "animated bounceInRight",
	      "leave-active-class": "animated bounceOutLeft"
	    }
	  }, [(_vm.tableDescView) ? _c('div', {
	    staticClass: "table-desc"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_c('h2', [_vm._v("【" + _vm._s(_vm.currentTableData.tablename) + "】" + _vm._s(_vm.currentTableData.info.comment))])]), _vm._v(" "), _c('div', {
	    staticClass: "table-row"
	  }, [_c('div', {
	    staticClass: "table"
	  }, [_c('table', [_c('tbody', [_c('tr', [_c('th', [_vm._v("字段名")]), _vm._v(" "), _c('th', [_vm._v("字段类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("备注")])]), _vm._v(" "), _vm._l((_vm.currentTableData.fields), function(item) {
	    return _c('tr', [_c('td', {
	      staticClass: "copy",
	      on: {
	        "click": function($event) {
	          _vm.CopyThat(item.column_name, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(item.column_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.column_type))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.column_default))]), _vm._v(" "), _c('td', {
	      staticClass: "copy",
	      on: {
	        "click": function($event) {
	          _vm.CopyThat(item.column_comment, $event)
	        }
	      }
	    }, [_vm._v(_vm._s(item.column_comment))])])
	  })], 2)])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
	    staticClass: "tools"
	  }, [_c('div', {
	    on: {
	      "click": _vm.viewTableList
	    }
	  }, [_vm._v("显示首页")]), _vm._v(" "), _c('div', {
	    on: {
	      "click": _vm.makeData
	    }
	  }, [_vm._v("生成数据")])]), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "beta-bar"
	  }, [_c('a', {
	    attrs: {
	      "href": "https://github.com/lonisy/data-dictionary"
	    }
	  }, [_vm._v("Fork Github")])])
	}]}

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('dictionary')], 1)
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.0113f958441118c95612.js